<template>
    <AppChartWrapper
            style="height: 100%;"
            :imageName="name"
    >
        <h4 class="subheading text-xs-left font-weight-regular section-title--color" slot="title">{{ name | unescapeString}}</h4>
        <BarChart
                class="pt-2"
                :chartData="totalCategoriesGroupCountChartData"
                :height="350"
                :options="totalCategoriesGroupCountChartOptions"
                slot="chart"
                v-if="summaryDataReady"
        />
    </AppChartWrapper>
</template>

<script>
	import {mapState} from 'vuex';
	import * as _ from "lodash";
	import BarChart from "./BarChart";
	import {abbrNum, thousandSeperator} from "../utils";
	import AppChartWrapper from "./AppChartWrapper";

	export default {
		name: "TotalCategoriesGroupCount",
		data() {
			return {
				totalCategoriesGroupCountChartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					layout: {
						padding: {
							top: 10,
							left: 10,
							right: 10,
							bottom: 15
						}
					},
					tooltips: {
						mode: 'label',
                        xPadding: 10,
                        titleSpacing: 4,
						callbacks: {
							afterTitle() {
								this.total = 0
							},
							label(tooltipItem, data) {
								const {label} = data.datasets[tooltipItem.datasetIndex]
								let total = data.datasets.map(data => data.data[tooltipItem.index]).reduce((acc, cur) => acc + cur);
								this.total = total;
								const value = parseInt(tooltipItem.value);
								let percentage = (parseFloat((value / this.total) * 100)).toFixed(1);

								return `${label}: ${thousandSeperator(value)} (${percentage}%)`
							},
							footer() {
								return `Total: ${thousandSeperator(this.total)}`
							},
						},
					},
					scales: {
						xAxes: [
							{
								gridLines: {
									display: false
								},
								barThickness: 5
							}
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									padding: 15,
                                    callback(value, index, values){
										return abbrNum(value,2);
                                    }
								}
							}
						]
					}
				},
			}
		},

		props: {
			name:{
				type: String,
                default: "Sentiment Driver"
            },

			categoryColor: {
				type: Object,
				required: true
			},

			selectedTags: {
				type: Array,
				default(){
					return []
                }
			},

			summaryData: {
				type: Object,
				required: true,
                default(){
					return {}
                }
			},

			summaryDataReady: {
				type: Boolean,
				required: true
			},

			totalCategoriesGroupSuggestedMax:{
				type: Number,
            },

            limit:{
				type: Number,
                required: true
            }
		},

		computed: {
			...mapState('mention', [
				'summaryReady'
			]),

			...mapState('sentiment', [
				'sentimentPageReady'
			]),

			orderTagSentimentCloudData() {
				return Object.entries(this.summaryData).sort((a, b) => {
					let [atotal, btotal] = [a,b].map(item => item[1].reduce((acc, cur) => acc+ cur.count, 0));
					return btotal-atotal;
				})
			},

			totalCategoriesLimit() {
				return !this.selectedTags.length < 1
					? Object.fromEntries(this.orderTagSentimentCloudData)
					: Object.fromEntries(this.orderTagSentimentCloudData.slice(0, this.limit));
			},

			totalCategoriesGroupCountChartData() {
                const barChartData = this.totalCategoriesLimit;
				let labels = Object.keys(barChartData);

				labels = this.selectedTags.length < 1 ? labels : labels.filter(l => this.selectedTags.includes(l));

				if (labels.length < 1) return {}

				const datasets = ['positive', 'negative', 'neutral', 'interest'].map((category) => {
					const count = labels.map(l => barChartData[l]).map((data) => {
						const cat = data.filter(d => d.category === category)
						if (cat.length > 0) {
							return parseInt(cat[0].count)
						}
						return 0
					});
					return {
						label: category,
                        data: count,
						backgroundColor: this.categoryColor[category],
					}
				}).filter(item => !item.data.every(val => val === 0));
				return {
                    labels,
					datasets
				}
			},
		},

		watch: {
			totalCategoriesGroupSuggestedMax: {
				handler(val) {
					if (val && val !== 0) {
						let yScale = this.totalCategoriesGroupCountChartOptions.scales.yAxes;
						let scale = yScale[0];
						scale.ticks.suggestedMax = val;
						this.$set(this.totalCategoriesGroupCountChartOptions.scales.yAxes, 0, scale)
					}
				},
				immediate: true
			}
		},

		components: {
			AppChartWrapper,
			BarChart
		}
	}
</script>

<style scoped>
    .chart-container {
        width: 51vw;
        position: relative;
    }

    .chart-wrapper > div:first-child {
        margin-top: -14px;
        margin-left: -14px;
    }
</style>
